import { Blueprint, createBlueprintFromShapeCfn, kitchenShapes } from '@rta/rta-blueprint-library';

import { NewSubmissionParams } from './types';

export type IslandDefinitionType = {
	label: string;
	image: string;
	definition: (params: NewSubmissionParams) => Blueprint | null;
};

export const islandDefinitions = (): Array<IslandDefinitionType> => {
	return Object.values(kitchenShapes)
		.flatMap((group) => group.options)
		.map((option) => {
			const { key, label, image } = option;
			return {
				label,
				image,
				definition: (params: NewSubmissionParams) => createBlueprintFromShapeCfn(key, params)
			};
		});
};
